import { gql } from '@apollo/client';

export const GET_TWITTER_APP_STORE_CATEGORIES = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterAppStoreCategories(request: $request) {
      ... on TwitterAppStoreCategoriesResponse {
        count
        next_cursor
        data
      }
    }
  }
`;

export const GET_TWITTER_CONVERSATION = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterConversations(request: $request) {
      ... on TwitterConversationsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_DEVICES = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterDevices(request: $request) {
      ... on TwitterDevicesResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_EVENTS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterEvents(request: $request) {
      ... on TwitterEventsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_INTERESTS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterInterests(request: $request) {
      ... on TwitterInterestsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_LANGUAGES = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterLanguages(request: $request) {
      ... on TwitterLanguagesResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_LOCATIONS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterLocations(request: $request) {
      ... on TwitterLocationsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_NETWORK_OPERATORS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterNetworkOperators(request: $request) {
      ... on TwitterNetworkOperatorsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_PLATFORM_VERSIONS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterPlatformVersions(request: $request) {
      ... on TwitterPlatformVersionsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_PLATFORMS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterPlatforms(request: $request) {
      ... on TwitterPlatformsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_TV_MARKETS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterTVMarkets(request: $request) {
      ... on TwitterTVMarketsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
export const GET_TWITTER_TV_SHOWS = gql`
  query GetList($request: TwitterTargetingOptionRequest!) {
    GetTwitterTVShows(request: $request) {
      ... on TwitterTVShowsResponse {
        count
        next_cursor
        data
      }
    }
  }
`;
